import { i18n } from 'i18n';

const getCountryFromLanguage = () => {
  const langsToCountry = {
    'ES-es': 'ES',
    fr: 'FR',
    en: 'UK',
  };

  return langsToCountry[i18n.language] || 'ES';
};

export default getCountryFromLanguage;
